import React from "react";
import { IconButton, InputAdornment, Tooltip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { COLORS } from "./constants";

export function CopyAdornment({ value, fieldId, copiedField, onCopy }) {
  return (
    <InputAdornment position="end">
      <Tooltip title={copiedField === fieldId ? "Copied" : "Copy"}>
        <IconButton size="small" onClick={() => onCopy(value, fieldId)} aria-label="Copy">
          {copiedField === fieldId
            ? <CheckCircleIcon sx={{ color: COLORS.green, fontSize: 17 }} />
            : <ContentCopyIcon sx={{ color: COLORS.muted,  fontSize: 17 }} />}
        </IconButton>
      </Tooltip>
    </InputAdornment>
  );
}
